export var Size = {
  Md: 'md',
  Lg: 'lg'
};